import { CCol, CFormCheck, CFormInput, CFormTextarea, CRow, CTooltip, CButton, CNav, CNavItem, CNavLink, } from '@coreui/react';
import { motion } from 'framer-motion';
import { Check, CircleAlertIcon, Info } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { SaveActivity } from './save-activity';

const QuestionTextInputFormBuilder = ({ setEditQuestion, allQuestions, setCurrentTextInputs, setIsOpenModal, addQuestions, setQuestionType, currentTextInputs, selectedEditDiagnosisQuestion, selectedEditDiagnosisQuestionIndex, fetchedQuestions, setFetchedQuestions, setCallAddFromMade, dropdownInput, setDropdownInput, mode, saveMode, saveQuestion, styling }) => {

    const [showRemark, setShowRemark] = useState(false);
    const [activeTab, setActiveTab] = useState("basic");
    const [selectedOptionsCondition, setSelectedOptionsCondition] = useState(null)
    const [selectedOptionValues, setSelectedOptionValues] = useState([])
    const [selectedOptionInfo, setSelectedOptionsInfo] = useState(null)

    console.log("current question ", currentTextInputs)
    const [questionObj, setQuestionObj] = useState({
        id: Date.now(),
        label: "",
        answer: "",
        isTextArea: false,
        isTextInputText: true,
        toolTipValue: "",
        isPretextToShow: false,
        type: "input",
        preText: "",
        postText: "",
        isRemark: "",
        remarkToShow: false,
        isPostTextToShow: false,
        isValueShowInAssessment: false,
        condition: null,
        historyOfDiagnosis: false,
    });

    const [linkedQuestionObj, setLinkedQuestionObj] = useState({});

    // useEffect(() => {
    //     console.log("In use Effect 1")
    //     console.log("***************************")
    //     console.log(currentTextInputs)
    //     console.log(mode)
    //     if (mode == "Edit") {
    //         console.log("In Edit ")
    //         setCurrentTextInputs(currentTextInputs || questionObj)
    //     } else {
    //         if (saveMode == "options") {
    //             setLinkedQuestionObj(currentTextInputs)
    //         }
    //     }

    // }, [dropdownInput])


    useEffect(() => {
        console.log("In useEffect 1");
        console.log("***************************");
        console.log(currentTextInputs);
        console.log(mode);

        if (!currentTextInputs) {
            console.log("currentTextInputs is undefined, initializing...");
            if (mode === "Edit") {
                setCurrentTextInputs(questionObj || {});
            } else {
                setCurrentTextInputs({});
            }
            return;
        }

        if (mode === "Edit") {
            console.log("In Edit mode");
            setCurrentTextInputs(currentTextInputs);
        } else {
            if (saveMode === "options") {
                setLinkedQuestionObj(currentTextInputs);
            }
        }
    }, [dropdownInput]);



    console.log("linkedQuestionObj", currentTextInputs)
    const handleSave = () => {

        if (saveMode === "options") {
            console.log("handleSave")
            saveQuestion(currentTextInputs);
        } else {
            // saveQuestion(questionObj);
            addQuestions('input')
            setCallAddFromMade(true)
            setIsOpenModal(false)
            //setQuestionType("")
        }
            SaveActivity("Added a question in Form Builder")
    }

    useEffect(() => {
        if (selectedOptionsCondition) {
            const allOptionsValues = [...allQuestions, ...fetchedQuestions?.questionData]
            const findSelectedValuesOfSelectedOptions = allOptionsValues.find(item => item.id === selectedOptionsCondition.value)
            setSelectedOptionsInfo(findSelectedValuesOfSelectedOptions)
            const allOptionForthis = findSelectedValuesOfSelectedOptions?.options?.map(item => item.label)
            setSelectedOptionValues(allOptionForthis)
        }
    }, [selectedOptionsCondition, allQuestions, fetchedQuestions])
    return (
        <motion.div
            className='custom-form-builder-theme__builder-modal rounded-3 p-4 position-relative'
            style={{ width: styling === 'show' ? '100%' : '70%', height: '85%', overflow: "auto" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className='d-flex align-items-center flex-column w-100 h-100'>
                <div style={{ zIndex: 5000 }} className="custom-form-builder-theme__builder-sticky justify-content-center position-sticky top-0 left-0 w-full px-4 pb-4">

                    <div className='custom-form-builder-theme__builder-header d-flex mt-4 justify-content-between border-top border-bottom align-items-center'>
                        <p className='p-2 m-0 text-center w-100  '>Form Builder</p>
                        <p className='p-2 m-0 text-center w-100'>Preview</p>
                    </div>
                </div>
                <CRow className='w-100   '>


                    <CCol xs={12} md={6} className='custom-form-builder-theme__builder-column d-flex justify-content-center flex-column gap-1 border-end'>
                        <div className='w-100 d-flex align-items-center justify-content-center  '>
                            <CNav variant="pills" role="tablist" >
                                {/* <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'basic'}
                                        onClick={() => setActiveTab("basic")}
                                    >
                                        Basics
                                    </CNavLink>
                                </CNavItem> */}

                                {/* <CNavItem>
                                    <CNavLink
                                        active={activeTab === 'conditions'}
                                        onClick={() => setActiveTab("conditions")}
                                    >
                                        Conditions
                                    </CNavLink>
                                </CNavItem> */}
                                {/* <CNavItem>
                                        <CNavLink
                                            active={activeTab === 'orders'}
                                            onClick={() => setActiveTab("orders")}
                                        >
                                            Orders
                                        </CNavLink>
                                    </CNavItem> */}
                            </CNav>
                        </div>
                        {activeTab === 'basic' && <div>
                            <div className='w-100'>
                                <p className='font-weight-medium mb-2'>Enter question</p>
                            <CFormInput
                                className="custom-form-builder-theme__input"
                                value={currentTextInputs.label}
                                    onChange={(e) =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            label: e.target.value
                                        }))
                                    }
                                    type='text'
                                    id='questionLabelInput'
                                    placeholder='Enter question...'
                                />
                            </div>
                            <div className='w-100 mt-1'>
                                <p className='font-weight-medium mb-2'>Tooltip / Suggestions</p>
                                <CFormInput
                                    className="custom-form-builder-theme__input"
                                    value={currentTextInputs.toolTipValue}
                                    onChange={(e) => {
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            toolTipValue: e.target.value
                                        }))
                                    }}
                                    type='text'
                                    id='questionEmailInput'
                                    placeholder=''
                                />
                            </div>

                            <div className='w-100 mt-1'>
                                <p className='font-weight-medium mb-2'>Description</p>
                                <CFormTextarea
                                    className="custom-form-builder-theme__textarea"
                                    value={currentTextInputs.providerInfo}
                                    onChange={(e) => {
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            providerInfo: e.target.value
                                        }))
                                    }}
                                    id='providerInfoTextArea'
                                    placeholder='Enter description here...'
                                />
                            </div>

                            <div className='w-100 my-2'>
                                <CFormCheck
                                    checked={currentTextInputs.isTextInputText}
                                    onChange={() =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            isTextArea: false,
                                            isTextInputText: true
                                        }))
                                    }
                                    id='flexCheckTextInput'
                                    label='Answer in Text Box'
                                />
                                <CFormCheck
                                    checked={currentTextInputs.isTextArea}
                                    onChange={() =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            isTextArea: true,
                                            isTextInputText: false
                                        }))
                                    }
                                    id='flexCheckTextArea'
                                    label=' Answer in Text Area'
                                />
                            </div>
                            <div className='w-100'>
                                <CFormCheck
                                    checked={currentTextInputs.isValueShowInAssessment}
                                    onChange={() =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            isPretextToShow: false,
                                            isPostTextToShow: false,
                                            preText: "",
                                            postText: "",
                                            isValueShowInAssessment: !prev.isValueShowInAssessment
                                        }))
                                    }
                                    id='assessmentCheck'
                                    label='Add answer to assessment '
                                />
                            </div>

                            <div className='w-100'>
                                <CFormCheck
                                    checked={currentTextInputs.historyOfDiagnosis}
                                    onChange={() =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            historyOfDiagnosis: !prev.historyOfDiagnosis
                                        }))
                                    }
                                    id='historyCheck'
                                    label='History of Diagnosis Question'
                                />
                            </div>

                            {/* <div className='w-100 ' onClick={() => setShowRemark((p) => !p)}>
                                <CFormCheck
                                    checked={currentTextInputs.remarkToShow}
                                    onChange={() =>
                                        setCurrentTextInputs((prev) => ({
                                            ...prev,
                                            remarkToShow: !prev.remarkToShow
                                        }))
                                    }
                                    id='remarkToShow'
                                    label='Add the remark'
                                />
                            </div> */}

                            {showRemark &&
                                <motion.div
                                    initial={{ height: 'auto', opacity: 0 }}
                                    animate={{ height: 'auto', opacity: 1 }}
                                    transition={{ duration: 0.3 }} // Adjusted duration for smoother transition
                                    className=' w-100'
                                >
                                    <p className='font-weight-medium mb-2'>Remark</p>
                                    <CFormInput
                                        className="custom-form-builder-theme__input"
                                        value={currentTextInputs.remarkText}
                                        onChange={(e) => {
                                            setCurrentTextInputs((prev) => ({
                                                ...prev,
                                                remarkText: e.target.value
                                            }))
                                        }}
                                        type='text'
                                        id='questionEmailInput'
                                        placeholder=''
                                    />
                                </motion.div>}
                        </div>}

                        {activeTab === 'conditions' && (
                            <div className='d-flex'>
                                <div className='w-100 h-100 d-flex gap-4 flex-column p-4  '>
                                    <div>
                                        <p className="font-semibold text-sm">This component should Display:</p>
                                        <Select
                                            options={[
                                                { value: 'true', label: 'True' },
                                                { value: 'false', label: 'False' },
                                            ]}
                                            onChange={(selectedOption) => {
                                                const isShowOnCondition = selectedOption.value === 'true';

                                                if (isShowOnCondition) {
                                                    setCurrentTextInputs((prevState) => ({
                                                        ...prevState,
                                                        condition: {
                                                            isMultipleSelect: false,
                                                            multipleOptions: [],
                                                            isShowOnCondition,
                                                            isAnswer: "",
                                                            questionId: "",
                                                        },
                                                    }));
                                                } else {
                                                    setCurrentTextInputs((prevState) => ({
                                                        ...prevState,
                                                        condition: null,
                                                    }));
                                                }


                                            }}
                                        />
                                    </div>


                                    <div>
                                        <p className='font-semibold text-sm'>When the form component:</p>
                                        <Select
                                            onChange={(e) => {
                                                setSelectedOptionsCondition(e)
                                                if (currentTextInputs.condition === null) {
                                                    setCurrentTextInputs((prevState) => ({
                                                        ...prevState,
                                                        condition: null,
                                                    }));
                                                } else {
                                                    setCurrentTextInputs((prevState) => ({
                                                        ...prevState,
                                                        condition: {
                                                            ...prevState.condition,
                                                            questionId: e.value,
                                                        },
                                                    }));
                                                }

                                            }}
                                            options={
                                                [...(allQuestions || []), ...(fetchedQuestions?.questionData || [])]
                                                    .filter(item => item)
                                                    .map((item, idx) => (
                                                        item?.id !== selectedEditDiagnosisQuestion?.id
                                                            ? { value: item.id, label: item.label }
                                                            : null
                                                    ))
                                                    .filter(option => option !== null)
                                            }
                                        ></Select>
                                    </div>

                                    <div className='d-flex gap-2 '>
                                        {selectedOptionValues?.map((item, idx) => {
                                            return (
                                                <CButton variant="outline"
                                                    color={currentTextInputs.condition && currentTextInputs.condition?.multipleOptions?.includes(item) ? 'primary ' : "secondary"}
                                                    onClick={() => {
                                                        if (currentTextInputs.isMultiple) {
                                                            if (currentTextInputs.condition.multipleOptions.includes(item)) {
                                                                setCurrentTextInputs((prevState) => ({
                                                                    ...prevState,
                                                                    condition: {
                                                                        ...prevState.condition,
                                                                        multipleOptions: prevState.condition.multipleOptions.filter((option) => option !== item),
                                                                    },
                                                                }));
                                                            }
                                                            else {
                                                                setCurrentTextInputs((prevState) => ({
                                                                    ...prevState,
                                                                    condition: {
                                                                        ...prevState.condition,
                                                                        multipleOptions: [...prevState.condition.multipleOptions, item],
                                                                    },
                                                                }));
                                                            }
                                                        }
                                                        else {
                                                            setCurrentTextInputs((prevState) => ({
                                                                ...prevState,
                                                                condition: {
                                                                    ...prevState.condition,
                                                                    multipleOptions: [item],
                                                                },
                                                            }));
                                                        }
                                                    }}>
                                                    {item}
                                                </CButton>
                                            )
                                        })}
                                    </div>


                                </div>
                                <div className='' style={{ position: 'relative', height: '68vh' }}></div>
                            </div>
                        )}

                        <div className='' style={{ position: 'relative', height: '38vh' }}></div>
                    </CCol>

                    <CCol xs={12} md={6} className=''>
                        <div className='w-100'>
                            <span className='d-flex align-items-center gap-2 py-2'>
                                <p className='p-0 m-0 text-left font-bold text-sm'>
                                    {currentTextInputs.label || 'Question'}
                                </p>
                                <CTooltip content={currentTextInputs.toolTipValue ? currentTextInputs.toolTipValue : "Add the tooltip"}>
                                    <Info size={16} />
                                </CTooltip>
                            </span>

                            {currentTextInputs.isTextArea && !currentTextInputs.isTextInputText && (
                                <CFormTextarea className="custom-form-builder-theme__textarea" placeholder='Enter answer here' />
                            )}
                            {currentTextInputs.isTextInputText && !currentTextInputs.isTextArea && (
                                <CFormInput className="custom-form-builder-theme__input" placeholder='Enter answer here' />
                            )}

                            {/* <motion.span
                                initial={{ height: currentTextInputs.isValueShowInAssessment ? 'auto' : 0, opacity: currentTextInputs.isValueShowInAssessment ? 1 : 0 }}
                                animate={{ height: currentTextInputs.isValueShowInAssessment ? 'auto' : 0, opacity: currentTextInputs.isValueShowInAssessment ? 1 : 0 }}
                                transition={{ duration: 0.3 }} // Adjusted duration for smoother transition
                                className='d-flex mt-2 align-items-center gap-2'
                            >
                                <Check size={20} className='bg-primary rounded-circle text-white' />
                                <p className='p-0 m-0'>Value is gonna show in assessment.</p>
                            </motion.span> */}

                            {/* <motion.span
                                initial={{ height: currentTextInputs.remarkToShow ? 'auto' : 0, opacity: currentTextInputs.remarkToShow ? 1 : 0 }}
                                animate={{ height: currentTextInputs.remarkToShow ? 'auto' : 0, opacity: currentTextInputs.remarkToShow ? 1 : 0 }}
                                transition={{ duration: 0.3 }} // Adjusted duration for smoother transition
                                className='d-flex mt-2 align-items-start gap-2 flex-column'
                            >
                                <span className="d-flex align-items-center gap-2"><Check size={20} className='bg-primary rounded-circle text-white' />
                                    <p className='p-0 m-0'>Showing the remarks for questions.</p></span>
                             
                            </motion.span> */}

                            {currentTextInputs.providerInfo && (
                                <div className="custom-form-builder-theme__provider-info" style={{ marginTop: '10px' }}>
                                    <p><span className="custom-form-builder-theme__provider-info-label">Provider Information:</span> {currentTextInputs.providerInfo}</p>
                                </div>
                            )}

                        </div>

                        <div className=" d-flex gap-2 my-2  0 w-full">
                            <CButton color='primary' className="px-4 ui-action-btn ui-action-btn--primary" onClick={() => { handleSave() }}>Save</CButton>
                            <CButton color="secondary" className="px-4 ui-action-btn ui-action-btn--secondary" onClick={() => {
                                setCurrentTextInputs({
                                    label: "",
                                    answer: "",
                                    isTextArea: false,
                                    isTextInputText: true,
                                    toolTipValue: "",
                                    isPretextToShow: false,
                                    preText: "",
                                    isRemark: "",
                                    remarkToShow: false,
                                    postText: "",
                                    type: "input",
                                    isPostTextToShow: false,
                                    isValueShowInAssessment: false,
                                }),

                                    setIsOpenModal(false), setQuestionType("")
                            }}>Cancel</CButton>
                        </div>
                    </CCol>

                </CRow>
            </div>

        </motion.div>
    );
};

export default QuestionTextInputFormBuilder;
